export function HeroVideo() {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      <div className="main-overlay" />
      <div className="main-overlay-overlay" />
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        poster="/images/hero.jpg"
        className="h-full w-full scale-125 object-cover grayscale"
      >
        <source src="/images/hero.webm" type="video/webm" />
        <source src="/hero.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
